import ReactMarkdown from 'react-markdown';

const MarkdownItem = ({children, ...props}) => (
  <ReactMarkdown
    disallowedTypes={[
      'html',
      'linkReference',
      'image',
      'imageReference',
    ]}
    linkTarget={'_blank'}
    {...props}
  >
    {children}
  </ReactMarkdown>
);

export default MarkdownItem;
